import React from 'react';
import { Phone } from 'lucide-react';
import { CompanyConfig } from '@/constants/cx-companies';

interface CXPreCallProps {
  config: CompanyConfig;
  onBeginCall: () => void;
}

export const CXPreCall: React.FC<CXPreCallProps> = ({
  config,
  onBeginCall,
}) => {
  return (
    <div className="min-h-screen bg-gray-100">
      {/* Header */}
      <div className="bg-white border-b border-gray-200">
        <div className="container mx-auto px-4 py-4">
          <div className="flex items-center justify-between">
            <div className="flex items-center gap-2 md:gap-4">
              <img src={config.logo} alt={config.name} className="h-6 md:h-8" />
              <div className="flex items-center gap-1">
                <span className="text-gray-400 text-xs md:text-sm">Powered by</span>
                <img src={config.hupoLogo} alt="Hupo" className="h-5 md:h-6 mt-0.5" />
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Main content */}
      <div className="container mx-auto px-4 py-8 md:py-16">
        <div className="max-w-2xl mx-auto">
          <div className="bg-white rounded-3xl shadow-lg p-6 md:p-12">
            <div className="flex flex-col items-center">
              {/* Avatar */}
              <div className="w-32 h-32 md:w-48 md:h-48 rounded-full bg-gray-200 flex items-center justify-center mb-6 md:mb-8">
                <div className="w-28 h-28 md:w-44 md:h-44 rounded-full bg-gray-300" />
              </div>

              {/* Status */}
              <p className="text-green-600 text-sm mb-2">Available</p>

              {/* Title */}
              <h2 className="text-xl md:text-2xl font-semibold mb-3 md:mb-4">
                {config.chat.agentTitle}
              </h2>

              {/* Description */}
              <p className="text-sm md:text-base text-gray-600 text-center max-w-md mb-6 md:mb-8">
                Your AI financial advisor for all things money: savings plans,
                investments strategies, and more. I'm here 24/7, minus the hold
                music.
              </p>

              {/* Start Call Button */}
              <button
                onClick={onBeginCall}
                className="flex items-center gap-2 px-6 md:px-8 py-2.5 md:py-3 rounded-full text-white font-medium transition-all hover:opacity-90 text-sm md:text-base"
                style={{ backgroundColor: config.colors.primary }}
              >
                <Phone className="w-4 h-4 md:w-5 md:h-5" />
                Start call
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};
